class proofreadRuleCtrl {
    constructor($scope, httpRequest, logger) {
        httpRequest.get_getIvatProofreadRegularConfig().then((res) => {
            const list = res.data.value
            if (list && list.length > 0) {
                $scope.list = list
            }
        })
        $scope.save = function save() {
            let flag = false
            for (let i = 0; i < $scope.list.length; i++) {
                if ($scope.list[i].isCheck != 0) flag = true
            }
            if (flag) {
                httpRequest.post_saveIvatProofreadRegularConfig($scope.list, '保存成功')
            } else {
                logger.logError('请至少选择一条要素保存')
            }
        }
    }
}

proofreadRuleCtrl.$inject = ['$scope', 'httpRequest', 'logger']
export default proofreadRuleCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/inputRule/proofreadRuleCtrl.js